import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import { setWidgetHoverAtom } from "atoms/interaction";
import { useSetAtom } from "jotai";
import { RootState } from "store/rootReducer";
import styled from "styled-components";

import ScreenshotActivity from "components/screenshot/ScreenshotActivity";
import { useScreenshotContext } from "components/screenshot/hooks";
import { useWellsFromFilter } from "components/well-list/hooks";

import { ChartsProvider } from "../../../contexts";
import { EntityKind } from "../../../models/entityKind";
import { uid } from "../../../utils";
import ChartWrapper from "./ChartWrapper";

const PopoutChartWellsData = () => {
  useWellsFromFilter();
  return null;
};

interface PopoutChartProps {
  entityKind: EntityKind;
}
const PopoutChart = ({ entityKind }: PopoutChartProps) => {
  const setWidgetHover = useSetAtom(setWidgetHoverAtom);
  const channelId = useSelector((state: RootState) => state.channel.channel);
  const channelData = sessionStorage.getItem(channelId);
  const chartSettings = channelData ? JSON.parse(channelData) : null;
  const { widget } = useScreenshotContext();
  const jwtToken = useSelector((state: RootState) => state.auth.jwtToken);
  const customWidgetIdRef = useRef(uid());
  const customWidgetId = customWidgetIdRef.current;

  useEffect(() => {
    function handleMouseMove() {
      setWidgetHover({ widgetId: customWidgetId, isHover: true });
      document.removeEventListener("mousemove", handleMouseMove);
    }
    // If mouse is already in the window, this will detect it after mount
    document.addEventListener("mousemove", handleMouseMove);
    return () => document.removeEventListener("mousemove", handleMouseMove);
  }, [customWidgetId, setWidgetHover]);

  return (
    <>
      {jwtToken && (
        <Wrapper
          onMouseEnter={() => setWidgetHover({ widgetId: customWidgetId, isHover: true })}
          onMouseLeave={() =>
            setWidgetHover({ widgetId: customWidgetId, isHover: false })
          }>
          {widget ? (
            <ActivityWrapper>
              <ScreenshotActivity />
            </ActivityWrapper>
          ) : (
            <div></div>
          )}
          <PopoutChartWellsData />
          <ChartsProvider
            id={customWidgetId}
            entityKind={entityKind}
            initialChartSettings={chartSettings}>
            <StyledChartWrapper />
          </ChartsProvider>
        </Wrapper>
      )}
    </>
  );
};

export default PopoutChart;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  height: 100vh;
  width: 100%;
`;

const ActivityWrapper = styled.div`
  border-right: 1px solid rgba(var(--color-text-rgb), 0.1);
  width: 359px;
`;

const StyledChartWrapper = styled(ChartWrapper)`
  .ChartPlot.screenshot {
    position: relative;
    top: 60px;
    min-height: auto;
    min-width: auto;
    max-width: none;
    max-height: none;
  }
`;
